import { useTranslations } from 'js/hooks/i18n';
import { useComponentProps } from 'js/hooks/component/useComponentProps';

export const useComponentTranslations = () => {
    const { tkPrefix } = useComponentProps();

    return useTranslations(tkPrefix);
};
